export const PROJECT_REQUEST_TABS = { LIST: 'list' };

export const PORTFOLIO_PROJECTREQUEST_SUMMARY_FILTER_TABS = {
  THIS_PORTFOLIO: 'THIS_PORTFOLIO',
  SUB_PORTFOLIOS: 'SUB_PORTFOLIOS',
  ALL: 'all'
};
